module.exports = __webpack_public_path__ + "img/top5.983f6a6f.svg";